<template>
	<span class="bchip"><span class="bdot" :style="{ background: color }"></span>{{ label || name }}</span>
</template>

<script>
// The brand colour map in one place. Accepts the short keys (TW, HG, CM, VT, TWK) and the Accounts2 keys.
const ALIAS = { TOWN_WEB: 'TW', HEYGOV: 'HG', CLERKMINUTES: 'CM', VANTEVE: 'VT', TWEAK: 'TWK' }
export const BRAND_COLORS = { TW: '#2563eb', HG: '#7a5af8', CM: '#12b76a', VT: '#f79009', TWK: '#0e9384' }
export const BRAND_NAMES = { TW: 'Town Web', HG: 'HeyGov', CM: 'ClerkMinutes', VT: 'Vanteve', TWK: 'Tweak' }
// brandKey('town_web') → 'TW', brandKey('hg') → 'HG', brandKey('') → ''
export function brandKey(brand) {
	const u = String(brand || '').toUpperCase()
	return ALIAS[u] || (BRAND_COLORS[u] ? u : '')
}

export default {
	name: 'PeBrandChip',
	props: { brand: { type: String, default: '' }, label: { type: String, default: '' } },
	computed: {
		code() { return brandKey(this.brand) },
		color() { return BRAND_COLORS[this.code] || '#98a2b3' },
		name() { return BRAND_NAMES[this.code] || this.brand },
	},
}
</script>
